import { CircularProgress } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

export interface ItemLoadingOverlayProps {
  className?: string
  size?: string | number
}

const ItemLoadingOverlay: React.FC<ItemLoadingOverlayProps> = ({ className, size = 48 }) => (
  <div className={className}>
    <CircularProgress size={size} color="primary" />
  </div>
)

const StyledItemLoadingOverlay = styled(ItemLoadingOverlay)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: not-allowed;
`

export default StyledItemLoadingOverlay
